export class CacheService {

    static cacheAvailable() {
        return 'caches' in self;
    }

    static async openCache() {
        if (this.cacheAvailable()) {
            return await caches.open('attachments');
        } else {
            return false;
        }
    }

    static async saveFile(name: string, file: File, directory = 'attachments') {
        const cache = await this.openCache();
        if (cache) {
            await cache.put('/' + directory + '/' + name, new Response(file));
        }
    }

    static async saveFileById(name: string, directory = 'attachments') {
        const cache = await this.openCache();
        if (cache){
            await cache.add('/' + directory + '/' + name);
        }
    }
}